import React, { useState } from 'react';
import appLogoImg from '../assets/images/app-logo.png';

interface AppLogoProps {
  className?: string;
  alt?: string;
}

export const AppLogo: React.FC<AppLogoProps> = ({ 
  className = "w-10 h-10", 
  alt = "Progress App Logo" 
}) => {
  const [imgSrc, setImgSrc] = useState<string>(appLogoImg);

  const handleError = () => {
    // If bundled image fails, try static route, then fallback png
    if (imgSrc === appLogoImg) {
      setImgSrc('/app-icon.png');
    } else if (imgSrc === '/app-icon.png') {
      setImgSrc('/pwa-icon-512.png');
    }
  };

  return (
    <img 
      src={imgSrc} 
      alt={alt} 
      className={`object-cover rounded-2xl shadow-sm border border-slate-100 dark:border-slate-800 shrink-0 ${className}`} 
      referrerPolicy="no-referrer"
      onError={handleError}
    />
  );
};

